import useAppContext from '../../hook/useAppContext'
import './load.css'

const Load = () => {

      const {user} = useAppContext()

      if(user.length !== 0) return 

      return (
            <div className="load_content">
                  <div className="load_circle"></div>
                  <span>Wait Loading...</span>
            </div>
      )
}

export default Load
